<forge-card class="no-padding">
  <forge-scaffold>
    <forge-toolbar slot="header">
      <h2 class="forge-typography--heading2">{{title}}</h2>
      <div slot="end">
        @if (selectType === CASCADING) {
          <forge-icon-button (click)="selectAll(true)">
            <forge-tooltip type="label" placement="bottom">Select all</forge-tooltip>
            <forge-icon name="checkbox_multiple_marked"></forge-icon>
          </forge-icon-button>
        }

        @if (selectType === CASCADING) {
          <forge-icon-button (click)="selectAll(false)">
            <forge-tooltip type="label" placement="bottom">Deselect all</forge-tooltip>
            <forge-icon name="checkbox_multiple_blank_outline"></forge-icon>
          </forge-icon-button>
        }

        <forge-icon-button (click)="expandAll(true)">
          <forge-tooltip type="label" placement="bottom">Expand all</forge-tooltip>
          <forge-icon name="expand"></forge-icon>
        </forge-icon-button>

        <forge-icon-button (click)="expandAll(false)">
          <forge-tooltip type="label" placement="bottom">Collapse all</forge-tooltip>
          <forge-icon name="arrow_collapse_vertical"></forge-icon>
        </forge-icon-button>
      </div>
    </forge-toolbar>
    <div slot="body" class="tree-view--body">
      <!-- igx tree does not allow recursively created nodes via templates -->
      <igx-tree #treeView [selection]="selectType" (nodeSelection)="nodeSelection($event)"
        [ngClass]="selectTypeClass">
        @for (node of nodes; track node) {
          <igx-tree-node [data]="node" [(selected)]="node.Selected"
            [(disabled)]="node.Disabled" (click)="nodeClicked(node, $event)">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node }"></ng-container>
            @for (child of node.Children; track child) {
              <igx-tree-node [data]="child" [(selected)]="child.Selected"
                [expanded]="child.Expanded" (click)="nodeClicked(child, $event)">
                <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child}"></ng-container>
                @for (grandChild of child.Children; track grandChild) {
                  <igx-tree-node [data]="grandChild"
                    [(selected)]="grandChild.Selected" [expanded]="grandChild.Expanded"
                    (click)="nodeClicked(grandChild, $event)">
                    <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: grandChild}">
                    </ng-container>
                    @for (greatGrandChild of grandChild.Children; track greatGrandChild) {
                      <igx-tree-node [data]="greatGrandChild"
                        [(selected)]="greatGrandChild.Selected" [expanded]="greatGrandChild.Expanded"
                        (click)="nodeClicked(greatGrandChild, $event)">
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGrandChild}">
                        </ng-container>
                        @for (greatGreatGrandChild of greatGrandChild.Children; track greatGreatGrandChild) {
                          <igx-tree-node
                            [data]="greatGreatGrandChild"
                            [(selected)]="greatGreatGrandChild.Selected"
                            [expanded]="greatGreatGrandChild.Expanded"
                            (click)="nodeClicked(greatGreatGrandChild, $event)">
                            <ng-container
                              *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGreatGrandChild}">
                            </ng-container>
                            @for (greatGreatGreatGrandChild of greatGreatGrandChild.Children; track greatGreatGreatGrandChild) {
                              <igx-tree-node
                                [data]="greatGreatGreatGrandChild"
                                [(selected)]="greatGreatGreatGrandChild.Selected"
                                [expanded]="greatGreatGreatGrandChild.Expanded"
                                (click)="nodeClicked(greatGreatGreatGrandChild, $event)">
                                <ng-container
                                  *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGreatGreatGrandChild}">
                                </ng-container>
                              </igx-tree-node>
                            }
                          </igx-tree-node>
                        }
                      </igx-tree-node>
                    }
                  </igx-tree-node>
                }
              </igx-tree-node>
            }
          </igx-tree-node>
        }

        <ng-template #nodeTemplate let-data>
          <div class="tree-node">
            <forge-icon [name]="data.Icon"></forge-icon>
            <span class="tree-node--text">{{data.Display}}</span>
          </div>
        </ng-template>
      </igx-tree>
    </div>
  </forge-scaffold>
</forge-card>